module.exports = __webpack_public_path__ + "media/spin.5a9d2f10.mp3";